"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircle_1 = require("@fortawesome/pro-light-svg-icons/faCircle");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var NewModal_1 = __importDefault(require("atomicComponents/organisms/Modal/NewModal/NewModal"));
var backend_1 = require("utils/backend");
var ResendAgreementModal = function (_a) {
    var rechCustomer = _a.item, onClose = _a.onClose;
    var _b = __read((0, backend_1.useCall)('rechCustomers-resendAgreement', { companyId: rechCustomer.companyId, customerIds: [rechCustomer.id] }), 2), cancelAgreement = _b[0], isSending = _b[1];
    return ((0, jsx_runtime_1.jsx)(NewModal_1.default, { open: true, textAlign: "left", icon: faCircle_1.faCircle, iconColor: "azzurro.main", title: "Send agreement again", subTitle: "You\u2019re about to send a new email to your client and restart a series of reminders.", footerContent: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "large", onClick: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "azzurro", size: "large", onClick: function () { return cancelAgreement()().then(onClose); }, isSending: isSending }, { children: "Send again" }))] })), maxWidth: "xs", onClose: onClose }));
};
exports.default = ResendAgreementModal;
